import { useState } from 'react';
import Nav from '../sections/Nav';
import Technology from '../sections/Technology';
import Footer from '../sections/Footer';
import ContactForm from '../ContactForm';
import { useSEO } from '../useSEO';

const TechnologyPage = () => {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const [contactFormMode, setContactFormMode] = useState('contact');

  useSEO({
    title: 'Technology | Nthra Labs',
    description: 'Neuro-symbolic AI and material knowledge graphs that translate buyer requirements into machine-verifiable logic, with every piece of evidence cryptographically signed and independently verifiable.',
    path: '/technology',
  });

  const openContactForm = (mode) => {
    setContactFormMode(mode);
    setIsContactFormOpen(true);
  };

  return (
    <div style={{ fontFamily: "'DM Sans',sans-serif", background: '#ffffff', color: '#1a1a1a', minHeight: '100vh' }}>
      <Nav onOpenContact={openContactForm} />
      <h1 className="sr-only">Technology — The Execution Layer for Machine-Verifiable Conformance</h1>
      <div style={{ paddingTop: 24 }} />
      <Technology />
      <Footer />
      <ContactForm
        isOpen={isContactFormOpen}
        onClose={() => setIsContactFormOpen(false)}
        mode={contactFormMode}
      />
    </div>
  );
};

export default TechnologyPage;
